export interface ISpec<TContext> {
  isSatisfiedBy(context: TContext): boolean;
  and(spec: ISpec<TContext>): ISpec<TContext>;
  or(spec: ISpec<TContext>): ISpec<TContext>;
  not(): ISpec<TContext>;
}


export abstract class Spec<TContext> implements ISpec<TContext> {
  abstract isSatisfiedBy(context: TContext): boolean;
  and(spec: ISpec<TContext>): ISpec<TContext> {
    return new AndSpec(this as unknown as ISpec<TContext>, spec);
  }
    or(spec: ISpec<TContext>): ISpec<TContext> {
        return new OrSpec(this as unknown as ISpec<TContext>, spec);
    }
    not(): ISpec<TContext> {
      return new NotSpec(this as unknown as ISpec<TContext>);
    }
}
export class AndSpec<TContext> extends Spec<TContext> {
  constructor(
    private left: ISpec<TContext>,
    private right: ISpec<TContext>,
  ) {
    super();
  }
  isSatisfiedBy(context: TContext): boolean {
    return this.left.isSatisfiedBy(context) && this.right.isSatisfiedBy(context);
  }
}

export class OrSpec<TContext> extends Spec<TContext> {
  constructor(
    private left: ISpec<TContext>,
    private right: ISpec<TContext>,
  ) {
    super();
  }

  isSatisfiedBy(context: TContext): boolean {
    return this.left.isSatisfiedBy(context) || this.right.isSatisfiedBy(context);
  }
}

export class NotSpec<TContext> extends Spec<TContext> {
  constructor(private spec: ISpec<TContext>) {
    super();
  }

  isSatisfiedBy(context: TContext): boolean {
    return !this.spec.isSatisfiedBy(context);
  }
}
